import React, { useEffect, useState } from "react";
import {
  DayName,
  SlotsContainer,
  TimeSlot,
  WeekdayContainer,
} from "./WeekScheduleStyles";
import { ScheduleSetting } from "../../../../types/schedulerSettings.types";
import { setLoading } from "../../../../stores/MainStore/MainStore";
import { updateSchedule } from "../../../../services/schedulerSettingsService";
import { AppError } from "../../../../services/classes";
import { toast } from "react-toastify";
import { getHourFromString } from "../../../../utils/functions";

interface Props {
  weekdayName: string;
  daySchedule: ScheduleSetting[];
}

const Weekday: React.FC<Props> = ({ weekdayName, daySchedule }) => {
  const [slotList, setSlotList] = useState<ScheduleSetting[]>(daySchedule);

  useEffect(() => {
    setSlotList(daySchedule);
  }, [daySchedule]);

  const handleClick = (slot: ScheduleSetting) => {
    const updatedSchedule = {
      ...slot,
      isAllowed: !slot.isAllowed,
    };

    setLoading(true);

    updateSchedule(updatedSchedule)
      .then((res) => {
        updateSlotList(res);
        toast.success("Horário alterado");
      })
      .catch((err: AppError) => {
        console.log(err.message);
        toast.error("Erro ao alterar horário");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const updateSlotList = (updatedSchedule: ScheduleSetting) => {
    const updatedSlots = slotList.map((slot) => {
      if (slot.id === updatedSchedule.id) return updatedSchedule;

      return slot;
    });

    setSlotList(updatedSlots);
  };

  const renderSlots = () => {
    if (!slotList?.length) {
      return <div>Sem horários</div>;
    }

    slotList.sort(
      (a, b) => getHourFromString(a.hour) - getHourFromString(b.hour)
    );

    return slotList.map((slot) => {
      return (
        <TimeSlot
          onClick={() => handleClick(slot)}
          isAllowed={slot.isAllowed}
          key={slot.id}
        >
          {slot.hour}
        </TimeSlot>
      );
    });
  };

  return (
    <WeekdayContainer>
      <DayName>{weekdayName}</DayName>
      <SlotsContainer>{renderSlots()}</SlotsContainer>
    </WeekdayContainer>
  );
};

export default Weekday;
